import Highcharts from 'highcharts'

/**
 * Custom Axis extension to allow emulation of negative values on a logarithmic
 * Y axis. Note that the scale is not mathematically correct, as a true
 * logarithmic axis never reaches or crosses zero.
 */
(function (H) {
  H.addEvent(H.Axis, 'afterInit', function () {
    const logarithmic = this.logarithmic;

    if (logarithmic && this.options.custom.allowNegativeLog) {

      // Avoid errors on negative numbers on a log axis
      this.positiveValuesOnly = false;

      // Override the converter functions
      logarithmic.log2lin = num => {
        const isNegative = num < 0;

        let adjustedNum = Math.abs(num);

        if (adjustedNum < 10) {
          adjustedNum += (10 - adjustedNum) / 10;
        }

        const result = Math.log(adjustedNum) / Math.LN10;
        return isNegative ? -result : result;
      };

      logarithmic.lin2log = num => {
        const isNegative = num < 0;

        let result = Math.pow(10, Math.abs(num));
        if (result < 10) {
          result = (10 * (result - 1)) / (10 - 1);
        }
        return isNegative ? -result : result;
      };
    }
  });
}(Highcharts));

const chart = {

  chartLegends: {
    'temperature': {
      'name': 'Temperatura',
      'unit': 'Celsius (&deg;C)',
      'symbol': '&deg;C'
    },
    'rain': {
      'name': 'Chuva',
      'unit': 'Milímetros (mm)',
      'symbol': 'mm'
    },
    'wind': {
      'name': 'Intensidade do vento',
      'unit': 'Quilômetros por hora (Km/h)',
      'symbol': 'Km/h'
    },
    'humidity': {
      'name': 'Umidade do ar',
      'unit': 'Porcentagem (%)',
      'symbol': '%'
    },
    'pressure': {
      'name': 'Pressão atmosférica',
      'unit': '(hPa)',
      'symbol': 'hPa'
    }
  },

  colors: {
    'temperature': {
      'double': {
        'lineColor': ['#DE685B', '#6BB8DD'],
        'backgroundColor': ['#fcd6d6', '#dbf4ff'],
      },
      'single': {
        'lineColor': ['#FF5722'],
        'backgroundColor': ['#ff572236'],
      },
    },
    'rain': {
      'single': {
        'lineColor': ['#AAAAAA'],
        'backgroundColor': ['#AAAAAA'],
      },
    },
    'wind': {
      'double': {
        'lineColor': ['#6BB8DD', '#AEBC3D'],
        'backgroundColor': ['#dbf4ff', '#EDF0D6'],
      },
      'single': {
        'lineColor': ['#AEBC3D'],
        'backgroundColor': ['#EDF0D6'],
      },
    },
    'humidity': {
      'double': {
        'lineColor': ['#DE685B', '#6BB8DD'],
        'backgroundColor': ['#fcd6d6', '#dbf4ff'],
      },
      'single': {
        'lineColor': ['#00B5E8'],
        'backgroundColor': ['#CAEEF9'],
      },
    },
    'pressure': {
      'single': {
        'lineColor': ['#C3D060'],
        'backgroundColor': ['#F1F4DD'],
      },
    },
  },

  /**
   * Controla a exibição dos diferentes tipos de gráficos
   */
  controlVariableChart: () => {
    $(document).on('click', '.act-control-variable-chart', function (e) {
      e.preventDefault()

      const id = $(this).data('id')
      const variable = $(this).data('variable')
      const type = $(this).data('type') || 'hourly'

      $(`#wrapper-chart-${id}`).find('.chart').addClass('_none')
      $(`#wrapper-chart-${id}`).find('.act-control-variable-chart').removeClass('-active')

      $(this).addClass('-active')
      $(`#${variable}-chart-${id}`).removeClass('_none')

      $(`#conditions-${id}`).removeClass(`-temperature -rain -wind -humidity -pressure`).addClass(`-${variable}`)

      if (type == 'daily') {
        $(`[data-detailed-card]`).addClass('_none')
        $(`[data-detailed-card=${variable}]`).removeClass('_none')

        $(`#min-max-legend`).removeClass(`-temperature -rain -wind -humidity -pressure`).addClass(`-${variable}`)
        $(`#chart-unit-daily`).html(chart.chartLegends[variable].unit)
      }

      $(`#chart-name`).html(chart.chartLegends[variable].name)
      $(`#chart-unit`).html(chart.chartLegends[variable].unit)

      chart.initChart({ variable, id, type })
    })
  },

  /**
   * Metodo que pinta a celula da previsao horaria de acordo com a hora atual
   * @param pos
   */
  highlightCell: (pos) => {
    const hours = new Date().getHours()
    const divider = 1
    const index = Math.floor(hours / divider)

    if (index == pos) return '-bold'
  },

  initChart: ({ variable = 'temperature', id = 1, type = 'hourly' }) => {
    const elem = $(`#wrapper-chart-${id}`)
    if (elem.length) {
      const data = JSON.parse(JSON.stringify(elem.data('infos')))
      const chartId = `${variable}-chart-${id}`

      if (type == 'daily') {
        const [formattedData, formattedData2] = chart.formatterDailyData(data, variable)

        chart.renderChart({
          chartId,
          variable,
          data: formattedData,
          data2: formattedData2,
          style: (variable == 'temperature' || variable == 'wind' || variable == 'humidity') ? 'double' : 'single',
          comparative: true
        })
      } else {
        const formattedData = chart.formatterHourlyData(data, variable)

        chart.renderChart({
          chartId,
          variable,
          data: formattedData
        })
      }
    }
  },

  /**
   * Formata os dados diários agrupando apenas pela variável atual
   * @param dailyData - Dados diários para 15 dias
   * @param variable - tipo do gráfico
   */
  formatterDailyData: (dailyData, variable) => {
    let data = []
    let data2 = []

    dailyData.forEach(item => {
      if (variable == 'temperature') {
        data.push(item.temperature.max || 0)
        data2.push(item.temperature.min || 0)
      }

      if (variable == 'rain') data.push(parseFloat(item.rain.precipitation) || 0)

      if (variable == 'wind') {
        data.push({ y: Math.round(item.wind.maxGust), direction: item.wind.direction })
        data2.push({ y: Math.round(item.wind.maxVelocity), direction: item.wind.direction })
      }

      if (variable == 'humidity') {
        data.push(Math.round(item.humidity.max || 0))
        data2.push(Math.round(item.humidity.min || 0))
      }

      if (variable == 'pressure') data.push(Math.round(item.rain.probability) || 0)
    })

    return [data, data2]
  },

  /**
   * Formata os dados horários agrupando apenas pela variável atual
   * @param hourly - Dados horários do dia apresentado
   * @param variable - tipo do gráfico
   */
  formatterHourlyData: (hourly, variable) => {
    let hourlySlice = hourly.slice(0, 23);
    let data = []

    const minTemp = parseInt($(`#min-temp-1`).html())
    const maxTemp = parseInt($(`#max-temp-1`).html())

    hourlySlice.forEach(item => {
      let value = null
      let itemReplace = item.date.replaceAll('T', ' ')

      const hour = itemReplace.split(" ")[1].split(":")[0]

      if (hour % 1 == 0) {
        if (variable == 'temperature') {
          if (item.temperature.temperature >= maxTemp) {
            value = maxTemp
          } else if (item.temperature.temperature <= minTemp) {
            value = minTemp
          } else {
            value = item.temperature.temperature
          }

          data.push(value || 0)
        }

        if (variable == 'rain') data.push(parseFloat(item.rain.precipitation) || 0)

        if (variable == 'wind') data.push({ y: Math.round(item.wind.velocity), direction: item.wind.direction })

        if (variable == 'humidity') data.push(Math.round(item.humidity.relativeHumidity) || 0)

        if (variable == 'pressure') data.push(Math.round(item.pressure.pressure) || 0)
      }
    })

    return data
  },

  getWindPosition: (direction) => {
    const positions = {
      "N": 180,
      "NNE": 202.5,
      "NE": 225,
      "ENE": 247.5,
      "E": 270,
      "ESE": 292.5,
      "SE": 315,
      "SSE": 337.5,
      "S": 0,
      "SSW": 22.5,
      "SW": 45,
      "WSW": 67.5,
      "W": 90,
      "WNW": 112.5,
      "NW": 135,
      "NNW": 157.5
    };
    return positions[direction];
  },

  /**
   * Retorna um ícone de previsão de acordo com o período do dia passado (madrugada, manhã, tarde, noite)
   * @param pos - posição para busca do ícone no array
   * @param dia - dia de referencia para busca
   */
  getIconObject: () => {
    const entries = Object.entries(twigData.hourlyForecast);
    const firstThreeEntries = entries.slice(0, 3);
    const data = firstThreeEntries
    const icons = [];
    const result = [];

    data.forEach(day => {
      const previsoesHorarias = day[1];

      previsoesHorarias.forEach(previsao => {
        const iconResource = previsao.icon.resource;
        icons.push(iconResource);
      });
    });

    for (let i = 0; i < 3; i++) {
      result.push(icons.slice(i * 24, (i + 1) * 24));
    }

    return result
  },

  getIcon: (array, index) => {
    return array[index]
  },

  getIconOld: (pos, id) => {
    const dailyForecastIcons = document.querySelectorAll(`[data-icon-id='${id}']`)

    const iconDawn = dailyForecastIcons[0].getAttribute(`data-icon`)
    const iconMorning = dailyForecastIcons[1].getAttribute(`data-icon`)
    const iconAfternoon = dailyForecastIcons[2].getAttribute(`data-icon`)
    const iconNight = dailyForecastIcons[3].getAttribute(`data-icon`)

    const conditions = [
      iconDawn,
      iconDawn,
      iconDawn,
      iconMorning,
      iconMorning,
      iconMorning,
      iconAfternoon,
      iconAfternoon,
      iconAfternoon,
      iconNight,
      iconNight,
      iconNight
    ]
    return conditions[pos]
  },

  /**
   * Método para criação do gráfico
   * @param chartId - id do elemento onde o gráfico será plotado
   * @param variable - tipo do gráfico
   * @param data - primero array de dados (obrigatório)
   * @param data2 - segundo array de dados (não obrigatório)
   * @param style - (single || double)
   * @param comparative - (true || false)
   */
  renderChart: async ({ chartId, variable, data = [], data2 = [], style = 'single', comparative = false }) => {
    const id = chartId.split('-')[2]
    const { backgroundColor, lineColor } = chart.colors[variable][style]

    // seta tipo do gráfico
    let type = 'areaspline'
    let series = []
    let categories = ['00h', '01h', '02h', '03h', '04h', '05h', '06h', '07h', '08h', '09h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h']
    let icons = chart.getIconObject()

    if (comparative) {
      categories = []

      const texts = document.querySelectorAll(`[data-item-day='${id}']`)
      texts.forEach(item => categories.push(item.innerHTML))
    }

    // busca maior e menor valor dentro dos arrays data e data2
    let allData = data2.length ? data.concat(data2) : data
    if (variable == 'wind') {
      allData = allData.map(function (wind) { return wind.y })
    }

    let smaller = Math.min.apply(null, allData) - 3
    let bigger = Math.max.apply(null, allData) + 3

    //if (smaller < 0) smaller = 0

    if (variable == 'rain') {
      // seta tipo do gráfico
      type = 'column'

      // se não tiver chuva mostra a informação 
      if (!Math.max.apply(null, allData)) document.getElementById(`rain-info-${id}`).classList.add('_flex')
      else {
        const restData = new Array(data.length).fill(null)

        // monta os objetos necessários para criar o gráfico de coluna
        data.forEach((rainData, index) => {
          const newData = new Array(data.length).fill(null)

          newData[index] = rainData
          restData[index] = bigger - rainData

          series.push({
            name: chart.chartLegends['rain']['name'],
            color: '#0180CD',
            data: newData
          })
        })

        series.unshift(
          {
            name: chart.chartLegends['rain']['name'],
            data: restData,
            color: '#E5E5E5',
            enableMouseTracking: false
          }
        )
      }
    } else {
      document.getElementById(`rain-info-${id}`).classList.remove('_flex')
      series = [
        {
          name: style == 'single' ? chart.chartLegends[variable].name : variable == 'wind' ? 'Rajada' : 'Máxima',
          data,
          color: backgroundColor[0],
          marker: { lineColor: lineColor[0] },
          lineColor: lineColor[0],
          dataLabels: { color: lineColor[0] },
        }
      ]

      if (data2.length) {

        series.push({
          name: style == 'single' ? chart.chartLegends[variable].name : variable == 'wind' ? chart.chartLegends[variable].name : 'Mínima',
          data: data2,
          color: backgroundColor[1],
          marker: { lineColor: lineColor[1] },
          lineColor: lineColor[1],
          dataLabels: { color: lineColor[1] },
        })

      }
    }

    Highcharts.wrap(Highcharts.SVGRenderer.prototype, 'init', function (proceed) {
      proceed.apply(this, Array.prototype.slice.call(arguments, 1));
      let elm = this.box.children[0]
      if (elm && elm.tagName === 'desc') {
        elm.remove()
      }
    });

    let loop = 0

    Highcharts.chart(chartId, {
      chart: {
        type,
        scrollablePlotArea: {
          minWidth: 560,
          scrollPositionX: 0
        },
        marginRight: 10,
        marginLeft: 10
      },
      title: {
        text: ''
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      xAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: 'transparent',
        lineWidth: 0,
        categories,
        labels: {
          step: 2,
          useHTML: true,
          formatter: function () {
            let icon = ''
            let bold = ''

            if (!comparative) {
              icon = `<img src='/dist/images/v2/svg/${chart.getIcon(icons[id - 1], this.pos)}.svg' height='35' width='35'>`
              bold = chart.highlightCell(this.pos / 2)
            }

            return (
              `<span class='divisions -${variable} -${style} _block _margin-t-5'>
                ${icon}
                <p class='_center -gray ${bold}' style='font-size:13px;'>${this.value}</p>
              </span>`
            )
          }
        }
      },
      yAxis: {
        type: 'logarithmic',
        custom: {
          allowNegativeLog: true
        },
        min: smaller,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        lineWidth: 0,
        lineColor: 'transparent',
        showAxis: false,
        title: {
          text: ' '
        },
        labels: {
          enabled: false
        }
      },
      tooltip: {
        style: {
          color: '#707070'
        },
        background: '#fff',
        borderWidth: 0,
        padding: 0,
        shadow: false,
        shared: true,
        useHTML: true,
        valueSuffix: chart.chartLegends[variable].symbol
      },
      plotOptions: {
        series: {
          dataLabels: {
            useHTML: true,
            enabled: true,
            style: {
              color: '#AAA',
              fontSize: '14px',
              fontWeight: 'normal',
            },
            formatter: function () {
              loop++

              if (variable == 'wind') {
                return (
                  `<span style="display:flex; flex-direction: column; align-items: center;">
                    <span class="arrow ${style == 'single' ? '-green' : loop <= 15 ? '-blue' : '-green'}" style="transform:rotate(${chart.getWindPosition(this.point.direction)}deg);"></span>
                    <span>${this.point.y}</span>
                  </span>`
                )
              } else if (variable == 'rain') {
                if (loop > data.length) return (
                  `<span class='highcharts-rain-value'>
                    ${this.point.y}
                  </span>`
                )
              } else if (variable == 'temperature') {
                if (loop > data.length) return (
                  `<span style="display:flex; flex-direction: column; align-items: center;">
                    <span>${this.point.y}</span>
                    </span>
                  </span>`
                )
              } else {
                return this.point.y
              }
            }
          }
        },
        column: {
          pointWidth: 12,
          stacking: 'normal',
          borderWidth: 0
        },
        areaspline: {
          dataLabels: {
            enabled: true
          },
          marker: {
            fillColor: '#FFFFFF',
            lineWidth: 1,
            enabled: true,
            symbol: 'circle',
            radius: 4
          },
          fillOpacity: 1,
          lineWidth: 1
        }
      },
      series
    })
  }
}

export default chart
